import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'

class Nav extends Component {
  constructor (props) {
    super(props)
    this.state = { active: 0 }
  }

  onSlideChange (index) {
    this.setState({ active: index })
  }

  render () {
    const nav = []
    const progress = []

    this.props.slides.forEach((slide, idx) => {
      const projectUrl = slide.project.value[0].slug.value.replace('project', 'projects')

      nav.push(
        <div key={idx} className={classnames({
          'slider__nav-item': true,
          'slider__nav-item--active': idx === this.state.active
        })}>
          <h4 className='slider__title'>
            <Link to={projectUrl}>
              {slide.title.value}
            </Link>
          </h4>
        </div>
      )

      progress.push(
        <span key={idx} className={classnames({
          'slider__bar': true,
          'slider__bar--active': idx === this.state.active
        })} />
      )
    })

    return (
      <div>
        <div className='slider__nav'>
          <div className='container-fluid'>{nav}</div>
        </div>
        <div className='slider__progress'>
          <div className='container-fluid'>{progress}</div>
        </div>
      </div>
    )
  }
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Slider/Nav/index.js